import axios from 'axios';
import { baseURL } from '../../../../config/Env';
import AsyncStorage from '@react-native-async-storage/async-storage';

const api = axios.create({
    baseURL
});

export const getAuthUsers = async ({ search, page, limit, status }) => {
    const dsToken = await AsyncStorage.getItem('token');
    const code = Math.floor(Math.random() * 1000000);

    return api.get('/gestao/usuario-privado', {
        headers: { authorization: dsToken },
        params: {
            search,
            page,
            limit,
            status,
            hashToResetCache: code
        }
    });
};

export const findPedidosAbertos = async ({ userList }) => {
    const dsToken = await AsyncStorage.getItem('token');
    return api.post(
        '/gestao/usuario-privado/pedido-aberto',
        {
            usuarios: userList
        },
        { headers: { authorization: dsToken } }
    );
};

export const saveAuthUser = async ({ login }) => {
    const dsToken = await AsyncStorage.getItem('token');
    const payload = { dsLogin: login };

    return api.post('/gestao/usuario-privado', payload, {
        headers: { authorization: dsToken }
    });
};

export const changeAuthUserStatus = async ({ userList, active }) => {
    const dsToken = await AsyncStorage.getItem('token');
    return api.put(
        '/gestao/usuario-privado',
        {
            usuarios: userList,
            fgAtivo: active
        },
        { headers: { authorization: dsToken } }
    );
};

export const updateAuthUser = async ({ idUsuario, login }) => {
    const dsToken = await AsyncStorage.getItem('token');

    return api.put(
        `/gestao/usuario-privado/${idUsuario}`,
        { dsLogin: login },
        { headers: { authorization: dsToken } }
    );
};
